import React from 'react';
import './error.css'
import Header from '../components/layout/header';
import HeroError from '../sections/heroerror';
import Footer from '../components/layout/footer';
import Responsivemsg from '../sections/responsive-msg';
import Preloader from "../sections/loading";
import  { useState } from "react";

const Error = () => {
    const [loading, setLoading] = useState(true);

    if (loading) {
        return <Preloader onFinish={() => setLoading(false)} />;}


    return ( 
        <>
            <Header />
            <main>
                <HeroError />
                <Responsivemsg />
            </main>
            <Footer />
        </>
     );
}
 
export default Error;